import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino";
import {
  getOddsByRunner,
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import PlaceBetUniversal from "./PlaceBetUniversal";
import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function CasinoWar() {
  const GAME_ID = "UNI_CASINO_WAR";
  const haveModule2 = GAME_ID?.includes("LUCKY_7_A");
  const haveCardSuit = GAME_ID?.includes("LUCKY_7_A");
  const [selected, setSelected] = React.useState("1");
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);

  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
  const placeBet = async (
    runnerName,

    isBack = true
  ) => {
    let odd = getOddsByRunner(odds, runnerName, true);

    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${odd?.marketId}_${odd?.selectionId}`;

    payload.runnerName = runnerName;
    payload[isBack ? "back" : "lay"] = odd[isBack ? "back1" : "lay1"];
    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = isBack ? "back" : "lay";
    payload.casinoGames = GAME_ID;

    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      setPlaceBetPayload(null);
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt;
    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);

  return (
    <app-casino-war _nghost-ng-c4172365497="" className="ng-star-inserted">
      <div _ngcontent-ng-c4172365497="" style={{ overflowY: "hidden" }}>
        <div _ngcontent-ng-c4172365497="">
          <app-video-player
            /*    */
            _ngcontent-ng-c4172365497=""
            _nghost-ng-c595356512=""
          >
            <div _ngcontent-ng-c595356512="" className="videoPlayer">
              <CasinoTV casinoGames={GAME_ID} />

              <div
                _ngcontent-ng-c595356512=""
                className="video-overlay ng-star-inserted"
              >
                <div _ngcontent-ng-c595356512="">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="round-id text-white"
                  >
                    RID: {odds?.roundId}
                  </div>

                  {odds?.playerCards
                    ?.filter((item) => item.forPerson === "DEALER")
                    ?.map((player) => (
                      <div _ngcontent-ng-c595356512="">
                        <h3 _ngcontent-ng-c595356512="" className="text-white">
                          {player?.forPerson}
                        </h3>
                        <div _ngcontent-ng-c595356512="">
                          {player?.cards?.map((card) => (
                            <img
                              _ngcontent-ng-c595356512=""
                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {showWinnerOverlay && (
                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new active"
                  >
                    <span _ngcontent-ng-c595356512="">
                      {" "}
                      {odds?.roundWinner} win{" "}
                    </span>
                    {/**/}
                  </div>
                  <span
                    _ngcontent-ng-c595356512=""
                    style={{ position: "absolute" }}
                  >
                    <canvas
                      _ngcontent-ng-c595356512=""
                      width="100vw"
                      height="100vh"
                    />
                  </span>
                  {/**/}
                </div>
              )}

              <div _ngcontent-ng-c595356512="" className="timer-overlay">
                <GenericCasinoTimer
                  time={odds?.seconds}
                  status={odds?.status}
                />
              </div>
            </div>

            <div
              _ngcontent-ng-c595356512=""
              id="rulesModal"
              tabIndex={-1}
              aria-labelledby="exampleModalLabelaexampleModalLabela"
              aria-hidden="true"
              className="modal fade"
            >
              <div
                _ngcontent-ng-c595356512=""
                className="modal-dialog rules-wrap"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  role="document"
                  id="rulesList___BV_modal_content_"
                  tabIndex={-1}
                  className="modal-content rules-content"
                >
                  <header
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_header_"
                    className="rules-wrap"
                  >
                    <a _ngcontent-ng-c595356512="">
                      <h3
                        _ngcontent-ng-c595356512=""
                        id="rulesList___BV_modal_title_"
                        data-bs-toggle="modal"
                        data-bs-target="#rulesModal"
                        className="modal-title"
                      >
                        {" "}
                        Rules
                      </h3>
                    </a>
                    <button
                      _ngcontent-ng-c595356512=""
                      type="button"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="close"
                    >
                      ×
                    </button>
                  </header>
                  <div
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_body_"
                    className="modal-body"
                  >
                    <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                  </div>
                  <div _ngcontent-ng-c595356512="">
                    <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                      <li _ngcontent-ng-c595356512="">
                        <a
                          _ngcontent-ng-c595356512=""
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          className="btnok"
                        >
                          OK
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </app-video-player>
        </div>
        <div
          _ngcontent-ng-c4172365497=""
          id="marketScroll"
          style={{ overflowY: "auto", height: 576 }}
          className="overflow-auto"
        >
          <ul
            _ngcontent-ng-c4172365497=""
            className="nav nav-tabs ng-star-inserted"
          >
            {odds?.playerCards
              ?.filter((item) => item.forPerson != "DEALER")
              ?.map((cards) =>
                cards?.cards?.map((card) => (
                  <li _ngcontent-ng-c4172365497="" className="nav-item col">
                    <a _ngcontent-ng-c4172365497="" className="nav-link game">
                      <img
                        _ngcontent-ng-c4172365497=""
                        className="card-img"
                        src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                      />
                    </a>
                  </li>
                ))
              )}
          </ul>
          <div _ngcontent-ng-c4172365497="" className="ng-star-inserted">
            <div
              _ngcontent-ng-c4172365497=""
              id="home"
              className="tab-pane sports"
            >
              <ul
                _ngcontent-ng-c4172365497=""
                className="nav nav-tabs-casino game-nav-bar menu-list-casino"
              >
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <li
                    onClick={() => setSelected(`${item}`)}
                    _ngcontent-ng-c4172365497=""
                    className="nav-item casinoname-item text-center aaa ng-star-inserted"
                  >
                    <a
                      _ngcontent-ng-c4172365497=""
                      className={`nav-link ${
                        selected === `${item}` ? "active" : ""
                      }`}
                    >
                      <div _ngcontent-ng-c4172365497="">{item}</div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            _ngcontent-ng-c4172365497=""
            className="card mt-2 ng-star-inserted"
          >
            <div _ngcontent-ng-c4172365497="" className="col">
              <div _ngcontent-ng-c4172365497="">
                <div
                  _ngcontent-ng-c4172365497=""
                  className="tbl-bets p-rltv sportbook-market-tbl playerABgTie"
                >
                  <div
                    _ngcontent-ng-c4172365497=""
                    className="d-flex odd-row justify-content-center flex-row align-items-center"
                  >
                    <div
                      _ngcontent-ng-c4172365497=""
                      className="ps-0 pe-0 boxPlayer align-items-end pe-3 justify-content-center"
                    >
                      <div _ngcontent-ng-c4172365497="" className="w-100">
                        <div _ngcontent-ng-c4172365497="" className="pb-1">
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="title marketName_Name text-center d-flex justify-content-center w-100 mw-100"
                          >
                            {" "}
                            WINNER {selected}{" "}
                          </span>
                        </div>
                      </div>
                      <div
                        onClick={() => placeBet(`WINNER ${selected}`)}
                        _ngcontent-ng-c4172365497=""
                        appratehighlight=""
                        className={`back oddsBox sportbook-minwidth p-rltv ${
                          odds?.status === "SUSPEND" ? "suspended" : ""
                        }`}
                      >
                        <a
                          _ngcontent-ng-c4172365497=""
                          className="d-flex flex-column p-0 align-items-center"
                          style={{
                            textDecoration: "none !important",
                            fontWeight: "600!important",
                            color: "black",
                            fontSize: 16,
                          }}
                        >
                          {getOddsByRunner(odds, `WINNER ${selected}`)}
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="d-flex justify-content-center"
                            style={{ fontSize: 11, fontWeight: 400 }}
                          >
                            {
                              getOddsByRunner(odds, `WINNER ${selected}`, true)
                                ?.backSize1
                            }
                          </span>
                        </a>
                      </div>
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="d-flex align-items-center p-0 pt-2 justify-content-center"
                        style={{ width: 100 }}
                      >
                        {getUniversalCasinoPlExposureByRunner(
                          exposure,
                          `WINNER ${selected}`
                        )}
                      </div>
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="d-flex align-items-center p-0 pt-2"
                      />
                    </div>
                  </div>
                  {placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                    `${
                      getOddsByRunner(odds, "WINNER " + selected, true)
                        ?.selectionId
                    }` && (
                    <PlaceBetUniversal
                      placeBetPayload={placeBetPayload}
                      setPlaceBetPayload={setPlaceBetPayload}
                      placeBet={placeBetCallApi}
                    />
                  )}
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c4172365497="" className="col">
              <div _ngcontent-ng-c4172365497="">
                <div
                  _ngcontent-ng-c4172365497=""
                  className="tbl-bets p-rltv sportbook-market-tbl playerABgTie"
                >
                  <div
                    _ngcontent-ng-c4172365497=""
                    className="d-flex odd-row justify-content-around ps-3 pe-3"
                  >
                    <div
                      _ngcontent-ng-c4172365497=""
                      className="d-flex flex-column align-items-center"
                    >
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="col-3 text-center"
                      >
                        <div _ngcontent-ng-c4172365497="" className="pb-1">
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="title marketName_Name text-center w-100 mw-100 d-flex justify-content-center"
                          >
                            {" "}
                            BLACK{" "}
                            <span _ngcontent-ng-c4172365497="" className="ms-2">
                              {" "}
                              ♠{" "}
                            </span>
                            <span _ngcontent-ng-c4172365497=""> ♣</span>
                          </span>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c4172365497=""
                        onClick={() => placeBet(`BLACK ${selected}`)}
                        className="col ps-0 pe-0 boxPlayer"
                      >
                        <div
                          _ngcontent-ng-c4172365497=""
                          appratehighlight=""
                          className={`back oddsBox sportbook-minwidth p-rltv ${
                            odds?.status === "SUSPEND" ? "suspended" : ""
                          }`}
                        >
                          <a
                            _ngcontent-ng-c4172365497=""
                            className="d-flex flex-column p-0 align-items-center"
                            style={{
                              textDecoration: "none !important",
                              fontWeight: "600!important",
                              color: "black",
                              fontSize: 16,
                            }}
                          >
                            {getOddsByRunner(odds, `BLACK ${selected}`)}
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="d-flex justify-content-center"
                              style={{ fontSize: 11, fontWeight: 400 }}
                            >
                              {
                                getOddsByRunner(odds, `BLACK ${selected}`, true)
                                  ?.backSize1
                              }
                            </span>
                          </a>
                        </div>
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="d-flex align-items-center p-0 pt-2 justify-content-center"
                          style={{ width: 100 }}
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `BLACK ${selected}`
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c4172365497=""
                      className="d-flex flex-column align-items-center"
                    >
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="col-3 text-center"
                      >
                        <div _ngcontent-ng-c4172365497="" className="pb-1">
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="title marketName_Name text-center w-100 mw-100 d-flex justify-content-center"
                          >
                            {" "}
                            RED{" "}
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="red ms-2"
                            >
                              {" "}
                              ♥
                            </span>
                            <span _ngcontent-ng-c4172365497="" className="red">
                              {" "}
                              ♦{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div
                        onClick={() => placeBet(`RED ${selected}`)}
                        _ngcontent-ng-c4172365497=""
                        className="col ps-0 pe-0 boxPlayer"
                      >
                        <div
                          _ngcontent-ng-c4172365497=""
                          appratehighlight=""
                          className={`back oddsBox sportbook-minwidth p-rltv ${
                            odds?.status === "SUSPEND" ? "suspended" : ""
                          }`}
                        >
                          <a
                            _ngcontent-ng-c4172365497=""
                            className="d-flex flex-column p-0 align-items-center"
                            style={{
                              textDecoration: "none !important",
                              fontWeight: "600!important",
                              color: "black",
                              fontSize: 16,
                            }}
                          >
                            {getOddsByRunner(odds, `RED ${selected}`)}
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="d-flex justify-content-center"
                              style={{ fontSize: 11, fontWeight: 400 }}
                            >
                              {
                                getOddsByRunner(odds, `RED ${selected}`, true)
                                  ?.backSize1
                              }
                            </span>
                          </a>
                        </div>
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="d-flex align-items-center p-0 pt-2 justify-content-center"
                          style={{ width: 100 }}
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `RED ${selected}`
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {["BLACK", "RED"].map(
                    (item) =>
                      placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                        `${
                          getOddsByRunner(odds, item + " " + selected, true)
                            ?.selectionId
                        }` && (
                        <PlaceBetUniversal
                          placeBetPayload={placeBetPayload}
                          setPlaceBetPayload={setPlaceBetPayload}
                          placeBet={placeBetCallApi}
                        />
                      )
                  )}
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c4172365497="" className="col">
              <div _ngcontent-ng-c4172365497="">
                <div
                  _ngcontent-ng-c4172365497=""
                  className="tbl-bets p-rltv sportbook-market-tbl playerABgTie"
                >
                  <div
                    _ngcontent-ng-c4172365497=""
                    className="d-flex odd-row justify-content-around ps-3 pe-3"
                  >
                    <div
                      _ngcontent-ng-c4172365497=""
                      className="d-flex flex-column align-items-center"
                    >
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="col-3 text-center"
                      >
                        <div _ngcontent-ng-c4172365497="" className="pb-1">
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="title marketName_Name text-center w-100 mw-100 d-flex justify-content-center"
                          >
                            {" "}
                            ODD
                          </span>
                        </div>
                      </div>
                      <div
                        onClick={() => placeBet(`ODD ${selected}`)}
                        _ngcontent-ng-c4172365497=""
                        className="col ps-0 pe-0 boxPlayer"
                      >
                        <div
                          _ngcontent-ng-c4172365497=""
                          appratehighlight=""
                          className={`back oddsBox sportbook-minwidth p-rltv ${
                            odds?.status === "SUSPEND" ? "suspended" : ""
                          }`}
                        >
                          <a
                            _ngcontent-ng-c4172365497=""
                            className="d-flex flex-column p-0 align-items-center"
                            style={{
                              textDecoration: "none !important",
                              fontWeight: "600!important",
                              color: "black",
                              fontSize: 16,
                            }}
                          >
                            {getOddsByRunner(odds, `ODD ${selected}`)}
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="d-flex justify-content-center"
                              style={{ fontSize: 11, fontWeight: 400 }}
                            >
                              {
                                getOddsByRunner(odds, `ODD ${selected}`, true)
                                  ?.backSize1
                              }
                            </span>
                          </a>
                        </div>
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="d-flex align-items-center p-0 pt-2 justify-content-center"
                          style={{ width: 100 }}
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `ODD ${selected}`
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c4172365497=""
                      className="d-flex flex-column align-items-center"
                    >
                      <div
                        _ngcontent-ng-c4172365497=""
                        className="col-3 text-center"
                      >
                        <div _ngcontent-ng-c4172365497="" className="pb-1">
                          <span
                            _ngcontent-ng-c4172365497=""
                            className="title marketName_Name text-center w-100 mw-100 d-flex justify-content-center"
                          >
                            {" "}
                            EVEN
                          </span>
                        </div>
                      </div>
                      <div
                        onClick={() => placeBet(`EVEN ${selected}`)}
                        _ngcontent-ng-c4172365497=""
                        className="col ps-0 pe-0 boxPlayer"
                      >
                        <div
                          _ngcontent-ng-c4172365497=""
                          appratehighlight=""
                          className={`back oddsBox sportbook-minwidth p-rltv ${
                            odds?.status === "SUSPEND" ? "suspended" : ""
                          }`}
                        >
                          <a
                            _ngcontent-ng-c4172365497=""
                            className="d-flex flex-column p-0 align-items-center"
                            style={{
                              textDecoration: "none !important",
                              fontWeight: "600!important",
                              color: "black",
                              fontSize: 16,
                            }}
                          >
                            {getOddsByRunner(odds, `EVEN ${selected}`)}
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="d-flex justify-content-center"
                              style={{ fontSize: 11, fontWeight: 400 }}
                            >
                              {
                                getOddsByRunner(odds, `EVEN ${selected}`, true)
                                  ?.backSize1
                              }
                            </span>
                          </a>
                        </div>
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="d-flex align-items-center p-0 pt-2 justify-content-center"
                          style={{ width: 100 }}
                        >
                          {getUniversalCasinoPlExposureByRunner(
                            exposure,
                            `EVEN ${selected}`
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {["ODD", "EVEN"].map(
                    (item) =>
                      placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                        `${
                          getOddsByRunner(odds, item + " " + selected, true)
                            ?.selectionId
                        }` && (
                        <PlaceBetUniversal
                          placeBetPayload={placeBetPayload}
                          setPlaceBetPayload={setPlaceBetPayload}
                          placeBet={placeBetCallApi}
                        />
                      )
                  )}
                </div>
              </div>
            </div>
            <div _ngcontent-ng-c4172365497="" className="col">
              <div _ngcontent-ng-c4172365497="">
                <div
                  _ngcontent-ng-c4172365497=""
                  className="tbl-bets p-rltv sportbook-market-tbl playerABgTie"
                >
                  <div
                    _ngcontent-ng-c4172365497=""
                    className="d-flex align-items-center justify-content-center"
                    style={{ fontSize: 16 }}
                  >
                    {getOddsByRunner(odds, `SPADE ${selected}`, true)?.back1}
                  </div>
                  <div
                    _ngcontent-ng-c4172365497=""
                    className="d-flex odd-row justify-content-between ps-3 pe-3"
                  >
                    {[
                      { name: "SPADE", symbol: "♠" },
                      { name: "CLUB", symbol: "♣" },
                      { name: "HEART", symbol: "♥" },
                      { name: "DIAMOND", symbol: "♦" },
                    ].map((item, i) => (
                      <div
                        onClick={() => placeBet(`${item?.name} ${selected}`)}
                        _ngcontent-ng-c4172365497=""
                        className="d-flex flex-column align-items-center"
                      >
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="col-3 text-center"
                        >
                          <div _ngcontent-ng-c4172365497="" className="pb-1">
                            <span
                              _ngcontent-ng-c4172365497=""
                              className="title marketName_Name text-center w-100 mw-100 d-flex justify-content-center"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c4172365497=""
                          className="col ps-0 pe-0 boxPlayer"
                        >
                          <div
                            _ngcontent-ng-c4172365497=""
                            appratehighlight=""
                            className={`back oddsBox sportbook-minwidth sportbook-minwidth4box p-rltv ${
                              odds?.status === "SUSPEND" ? "suspended" : ""
                            }`}
                          >
                            <a
                              _ngcontent-ng-c4172365497=""
                              className="d-flex flex-column p-0 align-items-center"
                              style={{
                                textDecoration: "none !important",
                                fontWeight: "600 !important",
                                color: i < 2 ? "black" : "red",
                                fontSize: 27,
                              }}
                            >
                              <span _ngcontent-ng-c4172365497="">
                                {" "}
                                {item?.symbol}{" "}
                              </span>
                            </a>
                          </div>
                          <div
                            _ngcontent-ng-c4172365497=""
                            className="d-flex align-items-center p-0 pt-2 justify-content-center"
                          >
                            {getUniversalCasinoPlExposureByRunner(
                              exposure,
                              `${item?.name} ${selected}`
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {[
                  { name: "SPADE", symbol: "♠" },
                  { name: "CLUB", symbol: "♣" },
                  { name: "HEART", symbol: "♥" },
                  { name: "DIAMOND", symbol: "♦" },
                ].map(
                  (item) =>
                    placeBetPayload?.marketIdWithSelectionId?.split("_")[1] ==
                      `${
                        getOddsByRunner(odds, item?.name + " " + selected, true)
                          ?.selectionId
                      }` && (
                      <PlaceBetUniversal
                        placeBetPayload={placeBetPayload}
                        setPlaceBetPayload={setPlaceBetPayload}
                        placeBet={placeBetCallApi}
                      />
                    )
                )}
              </div>
            </div>
          </div>

          <GetUniversalLastTenResult lastResult={lastResult} />
        </div>
      </div>
    </app-casino-war>
  );
}
